module.exports = __webpack_public_path__ + "static/media/conagualogo.0db5b667.png";